module.exports = __webpack_public_path__ + "img/any-mask15.eafc833a.png";